import React from 'react'

const page404 = () => (
  <div>
    <h1>Page Not Found.</h1>
  </div>
)
export default page404
